import { useEffect, useState } from "react";
import axios from "../../axios";
import { STORAGE_URL } from "../../constants";

export default function SettingPage() {
    const [form, setForm] = useState({
        site_name: "",
        address: "",
        phone: "",
        instagram: "", tiktok: "", facebook: "", shopee: "", tokopedia: "",
        logo: null,
        favicon: null,
    });
    const [error, setError] = useState("");
    const [initial, setInitial] = useState({});
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        axios.get("/admin/settings").then((res) => {
            setForm({ ...res.data, logo: null, favicon: null });
            setInitial(res.data);
        });
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);

        const formData = new FormData();
        Object.keys(form).forEach((key) => {
            if (form[key]) formData.append(key, form[key]);
        });

        try {
            await axios.post("/admin/settings", formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });
            alert("Setting disimpan");
        } catch (err) {
            setError("Gagal menyimpan data.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="card mt-4">
            <div className="card-header"><h4>Pengaturan Website</h4></div>
            <div className="card-body">
                {error && <div className="alert alert-danger">{error}</div>}
                <form onSubmit={handleSubmit}>
                    <div className="mb-3 form-group">
                        <label>Nama Website</label>
                        <input className="form-control" value={form.site_name} onChange={(e) => setForm({ ...form, site_name: e.target.value })} required />
                    </div>

                    <div className="mb-3 form-group">
                        <label>Alamat</label>
                        <textarea className="form-control" value={form.address || ""} onChange={(e) => setForm({ ...form, address: e.target.value })} />
                    </div>

                    <div className="mb-3 form-group">
                        <label>Telepon</label>
                        <input className="form-control" value={form.phone || ""} onChange={(e) => setForm({ ...form, phone: e.target.value })} />
                    </div>

                    <div className="mb-3 form-group">
                        <label>Instagram URL</label>
                        <input className="form-control" value={form.instagram || ""} onChange={(e) => setForm({ ...form, instagram: e.target.value })} />
                    </div>

                    <div className="mb-3 form-group">
                        <label>TikTok URL</label>
                        <input className="form-control" value={form.tiktok || ""} onChange={(e) => setForm({ ...form, tiktok: e.target.value })} />
                    </div>

                    <div className="mb-3 form-group">
                        <label>Facebook URL</label>
                        <input className="form-control" value={form.facebook || ""} onChange={(e) => setForm({ ...form, facebook: e.target.value })} />
                    </div>

                    <div className="mb-3 form-group">
                        <label>Shopee URL</label>
                        <input className="form-control" value={form.shopee || ""} onChange={(e) => setForm({ ...form, shopee: e.target.value })} />
                    </div>

                    <div className="mb-3 form-group">
                        <label>Tokopedia URL</label>
                        <input className="form-control" value={form.tokopedia || ""} onChange={(e) => setForm({ ...form, tokopedia: e.target.value })} />
                    </div>

                    <div className="mb-3 form-group">
                        <label>Logo</label><br />
                        {initial.logo && <img alt="" src={`${STORAGE_URL}${initial.logo}`} width={100} className="mb-2" />}
                        <input type="file" className="form-control" accept="image/*" onChange={(e) => setForm({ ...form, logo: e.target.files[0] })} />
                    </div>

                    <div className="mb-3 form-group">
                        <label>Favicon</label><br />
                        {initial.favicon && <img alt="" src={`${STORAGE_URL}${initial.favicon}`} width={32} className="mb-2" />}
                        <input type="file" className="form-control" accept="image/*" onChange={(e) => setForm({ ...form, favicon: e.target.files[0] })} />
                    </div>

                    <button type="submit" className="btn btn-primary" disabled={loading}>
                        {loading ? "Menyimpan..." : "Simpan"}
                    </button>
                </form>
            </div>
        </div>
    );
}
